import { useHeaderHeight } from '@react-navigation/elements'
import type { ReactNode, RefObject } from 'react'
import {
    Platform,
    ScrollView,
    type StyleProp,
    StyleSheet,
    View,
    type ViewStyle,
} from 'react-native'
import { useTheme } from 'react-native-paper'
import { SafeAreaView } from 'react-native-safe-area-context'

interface PageProps {
    children: ReactNode
    styles?: StyleProp<ViewStyle>
    noPad?: boolean
    scrollable?: boolean
    headerLess?: boolean
    scrollViewRef?: RefObject<ScrollView | null>
}

export function Page({
    children,
    styles: customStyles,
    noPad = false,
    scrollable = true,
    headerLess = false,
    scrollViewRef,
}: PageProps) {
    const theme = useTheme()
    const headerHeight = useHeaderHeight()
    const containerStyle = [
        styles.safeContainer,
        {
            backgroundColor: theme.colors.background,
            paddingTop: Platform.OS === 'ios' ? headerHeight : 16,
        },
    ]
    const contentStyle = [styles.content, noPad && styles.noPad, customStyles]

    let body: React.ReactNode = null

    if (scrollable) {
        body = (
            <ScrollView
                ref={scrollViewRef}
                style={[styles.scrollView, { backgroundColor: theme.colors.background }]}
                contentContainerStyle={[
                    contentStyle,
                    { paddingTop: Platform.OS === 'ios' ? headerHeight : 16 },
                ]}
            >
                {children}
            </ScrollView>
        )
    } else {
        body = <View style={[contentStyle, containerStyle]}>{children}</View>
    }

    if (headerLess) {
        body = (
            <SafeAreaView style={containerStyle} edges={['top', 'left', 'right']}>
                {body}
            </SafeAreaView>
        )
    }

    return body
}

const styles = StyleSheet.create({
    safeContainer: {
        flex: 1,
    },
    scrollView: {
        flex: 1,
    },
    content: {
        padding: 16,
        gap: 16,
        maxWidth: 1000,
        alignSelf: 'center',
        width: '100%',
    },
    noPad: {
        padding: 0,
        marginTop: 16,
    },
})
